import Typography from "../Typography";
import iconOpti from '../../assets/Icon_OPTI.svg'
import { useContext } from "@wordpress/element";
import ContextSearch from "@pages/Dashboard/ContextSearch";

export default function ContainerPage({ children, titulo, componenteLateral, className }) {
    const { dataPlanoUsuario } = useContext(ContextSearch)

    return (
        <div className={`pb-16 pr-8 pl-[calc(2em-20px)]`}>
            <div className="flex py-5">
                <img src={iconOpti} className="w-[4.07875em] pr-4" />
                {!dataPlanoUsuario?.data?.pagamentoCorrespondeAoPeriodo &&
                <Typography component="h3-container-page">Seja bem-vindo a Opti free</Typography>
                }
            </div>
            <div className="flex justify-between">
                <Typography className="py-6" component="h2">{titulo}</Typography>
                {componenteLateral}
            </div>
            <div className={className}>
                {children}
            </div>
        </div>
    )
}